// src/features/treinos/services/exerciseStatsService.js
//
// Leitura do WORKOUT_LOG (stats computados na leitura) + overrides manuais
// persistidos em PACIENTE/{uid}/EXERCICIO_STATS/{exercicioId}.
//   { pr_override?, ultima_override?, recomendada_override?, manual_flags }
// Inspecionado antes: a coleção EXERCICIO_STATS ainda não existia.

import { db } from "../../../firebaseConfig.js";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
  query,
  orderBy,
  limit as fsLimit,
} from "firebase/firestore";
import { normNome } from "../utils/exerciseStats.js";

// C6 (custo de leitura): janela de sessões lidas do WORKOUT_LOG.
// Consumidores: TreinoDetalhes (carga recomendada = última sessão de cada
// exercício), ExercicioEvolucaoOffcanvas (stats + gráfico, que exibe "últimas
// N" com N≤50 por padrão) e SessaoFinalizada (detecção de PR). 180 sessões ≈
// 10+ meses a 4 treinos/semana — PR/constância viram "dentro das últimas 180
// sessões" (documentado; antes era all-time lendo a coleção inteira).
// CREATED_AT (serverTimestamp) existe desde a 1ª versão do workoutLogService.
export const WORKOUT_SESSIONS_WINDOW = 180;

/** Lê as sessões WORKOUT_LOG mais recentes do usuário (janela C6). */
export async function fetchWorkoutSessions(uid) {
  if (!uid) return [];
  try {
    const snap = await getDocs(
      query(
        collection(db, "PACIENTE", uid, "WORKOUT_LOG"),
        orderBy("CREATED_AT", "desc"),
        fsLimit(WORKOUT_SESSIONS_WINDOW),
      )
    );
    const out = [];
    snap.forEach((d) => out.push({ id: d.id, ...d.data() }));
    return out;
  } catch (err) {
    console.error("[exerciseStats] fetchWorkoutSessions:", err);
    return [];
  }
}

/** Id do doc de overrides: EXERCISE_ID, senão "nome_<normalizado>". */
export function exercicioDocId({ exerciseId, nome }) {
  if (exerciseId) return String(exerciseId).replace(/[/.#$[\]]+/g, "_");
  const n = normNome(nome).replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  return n ? `nome_${n}` : null;
}

export async function getExercicioOverride(uid, docId) {
  if (!uid || !docId) return null;
  try {
    const snap = await getDoc(doc(db, "PACIENTE", uid, "EXERCICIO_STATS", docId));
    return snap.exists() ? snap.data() : null;
  } catch (err) {
    console.error("[exerciseStats] getExercicioOverride:", err);
    return null;
  }
}

/** Grava (merge) um override manual. patch ex.: { pr_override: 120 }. */
export async function saveExercicioOverride(uid, docId, patch) {
  if (!uid || !docId) return;
  try {
    await setDoc(
      doc(db, "PACIENTE", uid, "EXERCICIO_STATS", docId),
      { ...patch, UPDATED_AT: serverTimestamp() },
      { merge: true },
    );
  } catch (err) {
    console.error("[exerciseStats] saveExercicioOverride:", err);
    throw err;
  }
}
